<template>
    <div class="detailPage">
        <a-card :title="'试题详细'+'（'+'试题编号：'+$id+'）'">
            <div class="btn-Group" slot="extra">
                <a-button>
                    <a-icon type="sync" @click="syncPage" />试题刷新</a-button>
            </div>

            <div class="title" style="border-bottom:1px dashed #ddd;">
                <h1 style="text-align:center;">试题名称：{{detailInfo.name}}</h1>
            </div>

            <div class="list">
                <a-list :loading="loadingList" itemLayout="vertical" size="large" :dataSource="pageList.questions">
                    <a-list-item slot="renderItem" slot-scope="item" key="item.id">
                        <a-list-item-meta>
                            <a @click="editItemPage(item.id,item.bankId)" slot="title" v-html="item.stem">
                            </a>
                        </a-list-item-meta>
                    </a-list-item>
                </a-list>
            </div>

        </a-card>
    </div>
</template>
<script>
export default {
    name: 'detail',
    data () {
        return {
            $id: '',
            // pagination: {
            //     pageSize: 5,
            // },
            detailInfo: {},
            pageList: {
                isQeditor: '',
                exerciseId: '',
                questions: [],
            },
            loadingList: true
        }
    },
    methods: {
        getList () {
            this.$http.get('v1/learnonly/upload/detail/qeditor/' + this.$id).then(response => {
                if (response) {
                    this.pageList = response.data
                    this.loadingList = false
                }
            })
        },

        editItemPage (id, bankId) {
            let routeData = this.$router.resolve({ path: 'editPaper', query: { id: id, bankId: bankId } });
            window.open(routeData.href, '_blank');
        },

        syncPage () {
            this.getList()
        }
    },
    created () {
        this.detailInfo = {}
        if (this.$route.path === '/assistant/detail' && this.$route.query.id) {
            this.detailInfo = this.$route.query
            this.$id = this.$route.query.id
            this.getList()
        }
    }
}
</script>
<style scoped>
.detailPage {
    margin: 20px auto;
}
</style>
